"use client"
import {MenuBuilderShortcutModel} from "@/core/model/main.model";
import ToolsShortcutComponent from "@/core/widget/shortcut/toolsShortcut.component";
import {Provider} from "react-redux";
import {store} from "@/core/redux/store";

interface Props{
    shortcut:MenuBuilderShortcutModel
}
export default function ToolsShortcutContainerComponent(props:Props){
    return(
        <Provider store={store}>
            <ToolsShortcutComponent shortcut={props.shortcut}/>
        </Provider>
    )
}